module.exports = __webpack_public_path__ + "static/media/thumbnail.2be9eb85.jpg";